import { RootState } from '../core';

export const isLoadingFullPageSelector = (state: RootState) =>
  state.general.loadersFullPage.length > 0;

export const isAppInitializedSelector = (state: RootState) =>
  state.general.isAppInitialized;

export const currentOrderIdSelector = (state: RootState) =>
  state.general.currentOrderId;

export const getRoutesHistorySelector = (state: RootState) =>
  state.general.routesHistory;

export const getOperationSelector = (state: RootState) =>
  state.general.operation;

export const getErrorDescriptionSelector = (state: RootState) =>
  state.general.errorDescription;
